
export class TermsAndConditionSaveBean {
    termsUuid?: string;
    validTo?: Date;
    consentStatus?: string;

    constructor(termsUuidVal: string, validToDate: Date, consentStatusVal: string)
    {
        this.termsUuid = termsUuidVal;
        this.validTo = validToDate;
        this.consentStatus = consentStatusVal
    }
}